var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanagreement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 147,
    viewBox: "0 0 104 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 147,
    rx: 6,
    fill: "#FAE1CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 138C48.5 138 49 124.5 54.5 124.5C60 124.5 53.5 140.5 58.5 140.5C63.5 140.5 64.5 119 70.5 119C76.5 119 67.5 138 73 138C78.5 138 79.5 139.5 82 135.5",
    stroke: "#514C9F",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.718 108.829C87.0151 107.858 87.6858 107.045 88.5825 106.568C89.4792 106.092 90.5285 105.991 91.4996 106.288C92.4707 106.585 93.284 107.256 93.7606 108.152C94.2372 109.049 94.338 110.098 94.0409 111.07L93.4338 113.05L94.1443 113.266C94.5839 113.401 94.9927 113.62 95.3473 113.913C95.702 114.205 95.9957 114.564 96.2115 114.97C96.4273 115.376 96.561 115.82 96.605 116.278C96.6491 116.735 96.6026 117.197 96.4682 117.637L95.5453 120.655C95.4679 120.909 95.2928 121.122 95.0586 121.247C94.8244 121.371 94.5502 121.398 94.2964 121.321C94.0426 121.243 93.8299 121.068 93.7051 120.834C93.5804 120.6 93.5538 120.325 93.6312 120.072L94.5558 117.052C94.6135 116.864 94.6335 116.666 94.6146 116.47C94.5958 116.273 94.5385 116.083 94.4459 115.909C94.3534 115.735 94.2275 115.581 94.0755 115.455C93.9234 115.33 93.7481 115.236 93.5596 115.178L92.8501 114.965L87.9247 131.07C87.7751 131.559 87.5137 132.007 87.1611 132.378L83.1764 136.569C83.0483 136.703 82.8853 136.8 82.7056 136.847C82.526 136.894 82.3367 136.89 82.1592 136.835C81.9816 136.781 81.8227 136.678 81.7003 136.538C81.5778 136.399 81.4967 136.228 81.466 136.044L80.5055 130.344C80.4206 129.84 80.4542 129.323 80.6036 128.833L86.718 108.829Z",
    fill: "#514C9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 63,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#514C9F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 77,
    width: 82,
    height: 6,
    rx: 3,
    fill: "#514C9F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 92,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#514C9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 50.4394C22.2621 49.2237 19.121 46.8849 16.5632 43.3497C13.915 39.686 12.5936 35.5762 12.5936 30.9701V20.4863L25.9999 15.4781L39.4061 20.4863V30.9701C39.4061 35.5764 38.0846 39.6856 35.4363 43.3478C32.8784 46.8844 29.7374 49.2237 25.9999 50.4394Z",
    fill: "white",
    fillOpacity: 0.6,
    stroke: "#514C9F",
    strokeWidth: 3.2175
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2462 38.9847C24.9115 38.9847 23.9039 38.6177 23.2232 37.8836C22.5559 37.1362 22.2222 36.1018 22.2222 34.7805V31.8976C23.5035 31.8976 24.5245 31.8576 25.2852 31.7775C26.0594 31.6841 26.6333 31.5106 27.007 31.257C27.394 30.9901 27.6476 30.5963 27.7677 30.0758C27.8878 29.5553 27.9479 28.8613 27.9479 27.9937V25.4512H29.5295V27.9937C29.5295 28.9547 29.4361 29.7622 29.2492 30.4161C29.0757 31.0701 28.7687 31.5973 28.3283 31.9977C27.9012 32.3848 27.3139 32.6651 26.5665 32.8386C25.8325 32.9987 24.9115 33.0788 23.8038 33.0788V34.8406C23.8038 35.6948 23.9906 36.3821 24.3643 36.9026C24.738 37.4098 25.372 37.6634 26.2662 37.6634C27.0937 37.6634 27.6943 37.4232 28.068 36.9427C28.4551 36.4622 28.6486 35.8015 28.6486 34.9607H30.2102C30.1968 36.282 29.8431 37.283 29.1491 37.9637C28.4684 38.6444 27.5008 38.9847 26.2462 38.9847ZM21.3413 29.4552V28.254H32.1921V29.4552H21.3413ZM21.3413 25.9517V24.7305H32.1921V25.9517H21.3413Z",
    fill: "#514C9F",
    stroke: "#514C9F",
    strokeWidth: 0.715
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanagreement);
export default __webpack_public_path__ + "static/media/Loan agreement.de0ba95ea0b94e239ef92e5d94517fab.svg";
export { ForwardRef as ReactComponent };